export default "__VITE_ASSET__DRkmifd6__"